// Basin Plumbing Mock Data with SEO-optimized content

export const businessInfo = {
  name: "Basin Plumbing",
  phone: "(432) 552-8385",
  email: "accounting@basinplumbing.com",
  address: {
    street: "3730 Kermit Hwy",
    city: "Odessa",
    state: "TX",
    zip: "79764",
    full: "3730 Kermit Hwy, Odessa, TX 79764"
  },
  serviceAreas: [
    "Odessa", "Midland", "Andrews", "Big Spring", "Crane", 
    "Kermit", "Monahans", "Pecos", "Stanton", "Seminole"
  ],
  hours: {
    weekdays: "24/7",
    emergency: "24/7 Emergency Service Available"
  },
  social: {
    facebook: "https://www.facebook.com/BasinPlumbing/"
  },
  founded: "2015",
  license: "TX Master Plumber License #M-40123"
};

export const services = [
  {
    id: "waterline-replacement",
    slug: "waterline-replacement",
    title: "Waterline Replacement",
    shortDesc: "Expert waterline replacement and repair services for residential and commercial properties.",
    description: "Transforming your waterline has never been easier with our expert services! Is your waterline outdated or causing frequent issues? It's time to consider an upgrade. Our team specializes in modernizing waterline systems to improve efficiency and reliability.",
    icon: "Droplets",
    image: "https://images.pexels.com/photos/6419128/pexels-photo-6419128.jpeg?auto=compress&cs=tinysrgb&w=800",
    features: [
      "Complete waterline replacement",
      "Leak detection and repair",
      "Pipe relining services",
      "Water pressure optimization",
      "Emergency water line repairs"
    ],
    keywords: ["waterline replacement odessa", "water line repair midland", "pipe replacement permian basin"]
  },
  {
    id: "gas-line-replacement",
    slug: "gas-line-replacement-midland-odessa-texas",
    title: "Gas Line Replacement",
    shortDesc: "Safe and reliable gas line installation, repair, and replacement by certified professionals.",
    description: "Discover the benefits of top-tier gas line services with us! Gas lines are a critical part of your home's infrastructure, and safety is our top priority. Our team of certified professionals ensures that your gas lines are installed, repaired, or maintained with the utmost care.",
    icon: "Flame",
    image: "https://images.pexels.com/photos/16509869/pexels-photo-16509869.jpeg?auto=compress&cs=tinysrgb&w=800",
    features: [
      "Gas line installation",
      "Gas leak detection",
      "Gas line repairs",
      "Appliance gas connections",
      "Safety inspections"
    ],
    keywords: ["gas line replacement odessa", "gas plumber midland", "gas leak repair permian basin"]
  },
  {
    id: "sewer-line-replacement",
    slug: "sewer-line-replacement",
    title: "Sewer Line Replacement",
    shortDesc: "Professional sewer line services including repair, replacement, and maintenance.",
    description: "Unlock the power of seamless sewer line with our expert services! A well-functioning sewer line is the backbone of your property's plumbing system. Our seasoned professionals ensure that your sewer line operates smoothly.",
    icon: "Construction",
    image: "https://images.pexels.com/photos/37627673/pexels-photo-37627673.jpeg?auto=compress&cs=tinysrgb&w=800",
    features: [
      "Sewer line replacement",
      "Camera inspections",
      "Root removal",
      "Sewer cleaning",
      "Emergency sewer repairs"
    ],
    keywords: ["sewer line replacement odessa", "sewer repair midland", "sewer service permian basin"]
  },
  {
    id: "drain-cleaning",
    slug: "drain-cleaning-midland-odessa-texas",
    title: "Drain Cleaning",
    shortDesc: "Professional drain cleaning services to keep your plumbing flowing smoothly.",
    description: "Experience the transformative power of professional drain cleaning services with us! Say goodbye to stubborn clogs and slow drains. Our expert drain cleaning services ensure a free-flowing plumbing system.",
    icon: "ShowerHead",
    image: "/images/plumber-hydro-jetting.jpg",
    features: [
      "Hydro jetting",
      "Snake/auger cleaning",
      "Video inspection",
      "Preventive maintenance",
      "Emergency unclogging"
    ],
    keywords: ["drain cleaning odessa", "clogged drain midland", "drain service permian basin"]
  },
  {
    id: "water-heater",
    slug: "water-heater-installation-replacement-repair-midland-odessa-texas",
    title: "Water Heater Services",
    shortDesc: "Complete water heater installation, replacement, and repair services.",
    description: "Elevate your comfort and efficiency with our premium water heater solutions! Our experienced technicians ensure flawless water heater installations, optimizing performance and longevity.",
    icon: "Thermometer",
    image: "https://images.unsplash.com/photo-1594233078955-e1f73a02ebb2?w=800",
    features: [
      "Tank water heater installation",
      "Tankless water heater installation",
      "Water heater repair",
      "Water heater replacement",
      "Maintenance services"
    ],
    keywords: ["water heater replacement odessa", "tankless water heater midland", "water heater repair permian basin"]
  },
  {
    id: "trenchless-plumbing",
    slug: "trenchless-plumbing",
    title: "Trenchless Plumbing",
    shortDesc: "Modern trenchless technology for pipe repair without destroying your yard.",
    description: "Revolutionize your plumbing experience with our cutting-edge trenchless plumbing services! Trenchless plumbing is the modern solution to underground pipe repairs and replacements with minimal disturbance.",
    icon: "Shovel",
    image: "https://images.pexels.com/photos/29274530/pexels-photo-29274530.jpeg?auto=compress&cs=tinysrgb&w=800",
    features: [
      "Pipe bursting",
      "Pipe lining (CIPP)",
      "Directional drilling",
      "Minimal excavation",
      "Fast completion times"
    ],
    keywords: ["trenchless plumbing odessa", "pipe lining midland", "no-dig plumbing permian basin"]
  },
  {
    id: "medical-gas",
    slug: "medical-gas-installation",
    title: "Medical Gas Installation",
    shortDesc: "Specialized medical gas installation for healthcare facilities.",
    description: "Medical gas installation services ensure the safe and reliable delivery of essential gases like oxygen, nitrous oxide, and medical air within healthcare facilities.",
    icon: "Stethoscope",
    image: "https://images.unsplash.com/photo-1503789146722-cf137a3c0fea?w=800",
    features: [
      "Oxygen system installation",
      "Medical air systems",
      "Vacuum systems",
      "Nitrous oxide systems",
      "Compliance inspections"
    ],
    keywords: ["medical gas installation odessa", "healthcare plumbing midland", "hospital gas systems permian basin"]
  },
  {
    id: "residential",
    slug: "residential-plumbing",
    title: "Residential Plumbing",
    shortDesc: "Complete residential plumbing services for homeowners.",
    description: "Are plumbing issues wreaking havoc in your home? Don't fret; our expert residential plumbing services are here to save the day! Our team of skilled plumbers is at your service, ready to tackle any plumbing problem.",
    icon: "Home",
    image: "https://images.pexels.com/photos/7220892/pexels-photo-7220892.jpeg?auto=compress&cs=tinysrgb&w=800",
    features: [
      "Faucet repair & installation",
      "Toilet repair & replacement",
      "Garbage disposal services",
      "Fixture installation",
      "General plumbing repairs"
    ],
    keywords: ["residential plumber odessa", "home plumbing midland", "house plumber permian basin"]
  }
];

export const faqs = [
  {
    question: "What areas do you serve?",
    answer: "We proudly serve the entire Permian Basin region including Odessa, Midland, Andrews, Big Spring, Crane, Kermit, Monahans, Pecos, Stanton, and Seminole."
  },
  {
    question: "Do you offer 24/7 emergency plumbing services?",
    answer: "Yes! We offer 24/7 emergency plumbing services. Whether it's a burst pipe at midnight or a water heater failure on a holiday, our team is ready to help. Call (432) 552-8385 for immediate assistance."
  },
  {
    question: "How much does it cost to replace a water heater?",
    answer: "Water heater replacement costs vary depending on the type (tank vs tankless), capacity, and installation complexity. Traditional tank water heaters typically range from $1,200-$2,500 installed, while tankless units range from $2,500-$4,500. Contact us for a free estimate."
  },
  {
    question: "What is trenchless plumbing?",
    answer: "Trenchless plumbing is a modern pipe repair method that doesn't require digging up your yard. We use advanced techniques like pipe lining and pipe bursting to repair or replace underground pipes with minimal disruption to your property."
  },
  {
    question: "Do you offer financing options?",
    answer: "Yes! We partner with GreenSky to offer flexible financing options for major plumbing projects. This allows you to get the plumbing services you need now and pay over time with affordable monthly payments."
  },
  {
    question: "How do I know if I have a gas leak?",
    answer: "Signs of a gas leak include a sulfur or rotten egg smell, hissing sounds near gas lines, dead vegetation near gas lines, and higher than normal gas bills. If you suspect a gas leak, leave the area immediately and call us at (432) 552-8385."
  },
  {
    question: "Are your plumbers licensed and insured?",
    answer: "Absolutely! All our plumbers are licensed, insured, and continuously trained in the latest plumbing techniques and safety protocols. We are fully bonded and carry comprehensive liability insurance."
  },
  {
    question: "How often should I have my drains cleaned?",
    answer: "For preventive maintenance, we recommend professional drain cleaning every 1-2 years. However, if you notice slow drains, recurring clogs, or bad odors, you should schedule a cleaning sooner."
  }
];

export const testimonials = [
  {
    name: "Robert M.",
    location: "Odessa, TX",
    rating: 5,
    text: "Basin Plumbing saved us during a water heater emergency on a Sunday morning. They arrived within an hour and had our new water heater installed by afternoon. Exceptional service!",
    service: "Water Heater Replacement"
  },
  {
    name: "Sarah T.",
    location: "Midland, TX",
    rating: 5,
    text: "We had a major sewer line issue and Basin Plumbing used their trenchless technology to fix it without destroying our landscaping. Professional, affordable, and fast!",
    service: "Trenchless Plumbing"
  },
  {
    name: "Michael D.",
    location: "Odessa, TX",
    rating: 5,
    text: "The team at Basin Plumbing is top-notch. They fixed our gas line issue quickly and made sure everything was safe. Highly recommend for any gas plumbing needs.",
    service: "Gas Line Repair"
  },
  {
    name: "Jennifer L.",
    location: "Andrews, TX",
    rating: 5,
    text: "Best plumbers in the Permian Basin! They've handled multiple jobs for us and always deliver quality work at fair prices. Our go-to plumbing company.",
    service: "General Plumbing"
  },
  {
    name: "David K.",
    location: "Midland, TX",
    rating: 5,
    text: "Had a stubborn drain clog that other plumbers couldn't fix. Basin Plumbing came out with their hydro jetting equipment and cleared it right up. Amazing!",
    service: "Drain Cleaning"
  }
];

export const blogPosts = [
  {
    id: "emergency-plumber-odessa-midland",
    slug: "emergency-plumber-odessa-midland",
    title: "24/7 Emergency Plumber in Odessa & Midland: What to Do First",
    excerpt: "Burst pipe, sewage backup, or no hot water? Learn exactly what to do in a plumbing emergency, how to shut off your water, and when to call for help.",
    date: "2026-01-20",
    author: "Basin Plumbing Team",
    category: "Emergency",
    image: "https://images.unsplash.com/photo-1596394723269-b2cbca4e6313?w=800",
    readTime: "7 min read"
  },
  {
    id: "signs-water-heater-needs-replacement",
    slug: "signs-water-heater-needs-replacement",
    title: "7 Signs Your Water Heater Needs Replacement",
    excerpt: "Rusty water, strange noises, or a unit over 10 years old? Learn the 7 warning signs your water heater needs replacement—plus emergency red flags.",
    date: "2026-01-27",
    author: "Basin Plumbing Team",
    category: "Water Heaters",
    image: "https://images.unsplash.com/photo-1594233078955-e1f73a02ebb2?w=800",
    readTime: "9 min read"
  },
  {
    id: "water-heater-replacement-cost-odessa-midland",
    slug: "water-heater-replacement-cost-odessa-midland-tx",
    title: "Water Heater Replacement Cost in Odessa & Midland, TX (2026)",
    excerpt: "A transparent 2026 pricing guide for tank, tankless, gas and electric water heaters in the Permian Basin—plus labor, hidden fees, and ways to save.",
    date: "2026-01-26",
    author: "Basin Plumbing Team",
    category: "Water Heaters",
    image: "https://images.pexels.com/photos/19980200/pexels-photo-19980200.jpeg?auto=compress&cs=tinysrgb&w=800",
    readTime: "9 min read"
  },
  {
    id: "water-heater-replacement-cost",
    slug: "how-much-does-it-cost-to-replace-a-water-heater",
    title: "How Much Does It Cost to Replace a Water Heater?",
    excerpt: "A full breakdown of water heater replacement costs by type, the factors that change your quote, installation costs, and smart ways to save in West Texas.",
    date: "2026-01-15",
    author: "Basin Plumbing Team",
    category: "Water Heaters",
    image: "https://images.pexels.com/photos/10847199/pexels-photo-10847199.jpeg?auto=compress&cs=tinysrgb&w=800",
    readTime: "9 min read"
  },
  {
    id: "tankless-vs-tank",
    slug: "tankless-vs-tank-water-heaters",
    title: "Tankless vs Tank Water Heaters: Best for West Texas Homes",
    excerpt: "Compare cost, efficiency, lifespan, hard-water impact and a 15-year cost of ownership to find the right water heater for your Odessa or Midland home.",
    date: "2026-01-10",
    author: "Basin Plumbing Team",
    category: "Water Heaters",
    image: "https://images.pexels.com/photos/7664072/pexels-photo-7664072.jpeg?auto=compress&cs=tinysrgb&w=800",
    readTime: "10 min read"
  },
  {
    id: "trenchless-plumbing-guide",
    slug: "what-is-trenchless-plumbing",
    title: "What is Trenchless Plumbing? Methods, Benefits & Cost",
    excerpt: "Discover the trenchless methods—pipe bursting, CIPP lining, slip lining, directional drilling—plus the benefits, limitations, and costs of no-dig repair.",
    date: "2026-01-05",
    author: "Basin Plumbing Team",
    category: "Trenchless",
    image: "https://images.pexels.com/photos/37627673/pexels-photo-37627673.jpeg?auto=compress&cs=tinysrgb&w=800",
    readTime: "7 min read"
  },
  {
    id: "pipe-bursting",
    slug: "pipe-bursting",
    title: "What is Pipe Bursting? Trenchless Pipe Replacement Explained",
    excerpt: "How pipe bursting replaces old or collapsed pipes with minimal digging—the process, equipment, advantages, and when it's the right method.",
    date: "2026-01-08",
    author: "Basin Plumbing Team",
    category: "Trenchless",
    image: "https://images.pexels.com/photos/29274530/pexels-photo-29274530.jpeg?auto=compress&cs=tinysrgb&w=800",
    readTime: "5 min read"
  },
  {
    id: "drain-cleaning-services",
    slug: "drain-cleaning-services",
    title: "Professional Drain Cleaning Services: When DIY Isn't Enough",
    excerpt: "Why store-bought cleaners fail, the warning signs of a serious clog, and how camera inspection and hydro jetting solve drain problems for good.",
    date: "2026-01-12",
    author: "Basin Plumbing Team",
    category: "Drain Cleaning",
    image: "/images/plumber-hydro-jetting.jpg",
    readTime: "6 min read"
  },
  {
    id: "ac-drain-line-cleaner",
    slug: "ac-drain-line-cleaner",
    title: "A/C Drain Line Cleaner: Clear & Prevent Clogs",
    excerpt: "Learn what causes A/C drain line clogs, the best cleaners, a safe DIY method, and prevention tips to avoid costly water damage to your home.",
    date: "2025-12-20",
    author: "Basin Plumbing Team",
    category: "Maintenance",
    image: "https://images.unsplash.com/photo-1505695715220-3a366d958259?w=800",
    readTime: "6 min read"
  }
];

export const stats = [
  { value: "10+", label: "Years Experience" },
  { value: "5000+", label: "Jobs Completed" },
  { value: "24/7", label: "Emergency Service" },
  { value: "100%", label: "Satisfaction Guaranteed" }
];

export const badges = [
  { name: "HomeAdvisor Screened & Approved", image: "/badges/soap-solid-border.png" },
  { name: "Top Rated Professional", image: "/badges/toprated-solid-border.png" },
  { name: "Elite Service Professional", image: "/badges/elite-solid-border.png" },
  { name: "1 Year Guarantee", image: "/badges/1year-solid-border.png" }
];

export const galleryImages = [
  { src: "/images/plumber-kitchen-sink.jpg", alt: "Basin Plumbing technician repairing a kitchen sink" },
  { src: "/images/plumber-hydro-jetting.jpg", alt: "Plumber hydro jetting a sewer line" },
  { src: "https://images.unsplash.com/photo-1594233078955-e1f73a02ebb2?w=600", alt: "Water heater installation" },
  { src: "https://images.pexels.com/photos/6419128/pexels-photo-6419128.jpeg?auto=compress&cs=tinysrgb&w=600", alt: "Plumber installing steel water pipes" },
  { src: "https://images.unsplash.com/photo-1503789146722-cf137a3c0fea?w=600", alt: "Pipe wrenches and plumbing tools" },
  { src: "https://images.pexels.com/photos/16509869/pexels-photo-16509869.jpeg?auto=compress&cs=tinysrgb&w=600", alt: "Plumber repairing pipe fittings" },
  { src: "https://images.pexels.com/photos/29274530/pexels-photo-29274530.jpeg?auto=compress&cs=tinysrgb&w=600", alt: "Underground pipe installation" },
  { src: "https://images.pexels.com/photos/7220892/pexels-photo-7220892.jpeg?auto=compress&cs=tinysrgb&w=600", alt: "Plumber adjusting pipe under a sink" }
];

export const projects = [
  {
    id: "trenchless-sewer-midland",
    title: "Trenchless Sewer Line Replacement",
    service: "Trenchless Plumbing",
    serviceUrl: "/services/trenchless-plumbing",
    location: "Midland, TX",
    summary: "Replaced an 80-ft collapsed clay sewer line using pipe bursting — no trench across the yard, finished in a single day.",
    image: "https://images.pexels.com/photos/29274530/pexels-photo-29274530.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: "tankless-water-heater-odessa",
    title: "Tankless Water Heater Installation",
    service: "Water Heater Services",
    serviceUrl: "/services/water-heater-installation-replacement-repair-midland-odessa-texas",
    location: "Odessa, TX",
    summary: "Installed a high-efficiency gas tankless unit paired with a water softener to handle Permian Basin hard water.",
    image: "https://images.unsplash.com/photo-1594233078955-e1f73a02ebb2?w=800"
  },
  {
    id: "water-line-replacement-odessa",
    title: "Main Water Line Replacement",
    service: "Waterline Replacement",
    serviceUrl: "/services/waterline-replacement",
    location: "Odessa, TX",
    summary: "Swapped a corroded galvanized line for durable PEX — doubled water pressure and cut the homeowner's monthly bill.",
    image: "https://images.pexels.com/photos/6419128/pexels-photo-6419128.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: "hydro-jetting-midland",
    title: "Emergency Drain Hydro Jetting",
    service: "Drain Cleaning",
    serviceUrl: "/services/drain-cleaning-midland-odessa-texas",
    location: "Midland, TX",
    summary: "Cleared a fully blocked main line with hydro jetting and a camera inspection — same-day emergency response.",
    image: "/images/plumber-hydro-jetting.jpg"
  },
  {
    id: "gas-line-big-spring",
    title: "Outdoor Kitchen Gas Line",
    service: "Gas Line Replacement",
    serviceUrl: "/services/gas-line-replacement-midland-odessa-texas",
    location: "Big Spring, TX",
    summary: "Ran and pressure-tested a new gas line for an outdoor kitchen, completed with full city inspection and sign-off.",
    image: "https://images.pexels.com/photos/16509869/pexels-photo-16509869.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: "kitchen-repipe-odessa",
    title: "Kitchen Repipe & Fixture Install",
    service: "Residential Plumbing",
    serviceUrl: "/services/residential-plumbing",
    location: "Odessa, TX",
    summary: "Repiped under-sink supply lines and installed new fixtures during a complete kitchen remodel.",
    image: "/images/plumber-kitchen-sink.jpg"
  }
];

export const careers = [
  {
    title: "Licensed Plumber",
    type: "Full-time",
    location: "Odessa, TX",
    description: "We're looking for experienced licensed plumbers to join our growing team. Competitive pay, benefits, and company vehicle provided."
  },
  {
    title: "Plumber's Apprentice",
    type: "Full-time",
    location: "Odessa, TX",
    description: "Start your plumbing career with Basin Plumbing. We offer paid training, mentorship from experienced plumbers, and a clear path to licensure."
  }
];
